<template xmlns:v-on="http://www.w3.org/1999/xhtml" xmlns:v-bind="http://www.w3.org/1999/xhtml"
          xmlns:v="http://www.w3.org/1999/xhtml">
    <header v-bind:class="{with_line: this.$route.path != ('/' + lang) && this.$route.path != ('/' + lang + '/') && this.$route.path != '/'}">
        <div class="holder big">
            <a class="alogo" v-bind:href="'/' + lang + '/'"><img class="logo" src="../images/logo.png"/></a>
            <nav>
                <ul>
                    <li>
                        <div class="wrap">
                            <span class="title">{{ content[lang]['SOLUTIONS'] }}</span>
                            <ul class="submenu">
                                <li><a v-bind:href="'/' + lang + '/solutions/platform'" v-on:click="closeMenu">GL Enterprise Platform</a></li>
                                <li><a v-bind:href="'/' + lang + '/solutions/cloud-credit'" v-on:click="closeMenu">Cloud Credit</a></li>
                                <li><a v-bind:href="'/' + lang + '/solutions/bid-pro'" v-on:click="closeMenu">Bid Pro</a></li>
                                <li><a v-bind:href="'/' + lang + '/solutions/loyalty'" v-on:click="closeMenu">Loyalty</a></li>
                                <li><a v-bind:href="'/' + lang + '/solutions/global-centre'" v-on:click="closeMenu">Global Centre</a></li>
                                <li><a v-bind:href="'/' + lang + '/solutions/resource-management'" v-on:click="closeMenu">Resource Management</a></li>
                                <li><a v-bind:href="'/' + lang + '/solutions/aspa'" v-on:click="closeMenu">ASPA</a></li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <div class="wrap">
                            <span class="title">{{ content[lang]['SERVICES'] }}</span>
                            <ul class="submenu">
                                <li><a v-bind:href="'/' + lang + '/services/engineering'" v-on:click="closeMenu">{{ content[lang]['ENGINEERING'] }}</a></li>
                                <li><a v-bind:href="'/' + lang + '/services/development'" v-on:click="closeMenu">{{ content[lang]['DEVELOPMENT'] }}</a></li>
                                <li><a v-bind:href="'/' + lang + '/services/consulting'" v-on:click="closeMenu">{{ content[lang]['CONSULTING'] }}</a></li>
                            </ul>
                        </div>
                    </li>
                    <li><a v-bind:href="'/' + lang + '/news'" v-on:click="closeMenu">{{ content[lang]['PRESS_CENTER'] }}</a></li>
                    <li>
                        <div class="wrap">
                            <span class="title">{{ content[lang]['COMPANY'] }}</span>
                            <ul class="submenu">
                                <li><a v-bind:href="'/' + lang + '/company/about'" v-on:click="closeMenu">{{ content[lang]['ABOUT_COMPANY'] }}</a></li>
                                <li><a v-bind:href="'/' + lang + '/company/documents'" v-on:click="closeMenu">{{ content[lang]['DOCUMENTS'] }}</a></li>
                                <li><a v-bind:href="'/' + lang + '/company/career'" v-on:click="closeMenu">{{ content[lang]['CAREER'] }}</a></li>
                                <li><a v-bind:href="'/' + lang + '/company/contacts'" v-on:click="closeMenu">{{ content[lang]['CONTACTS'] }}</a></li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <div class="lang_mobile">
                    <a v-bind:class="{curr: lang == 'ru' }" v-on:click="closeMenu" href="/ru">{{ langName('ru') }}</a>
                    <a v-bind:class="{curr: lang == 'en' }" v-on:click="closeMenu" href="/en">{{ langName('en') }}</a>
                    <a v-bind:class="{curr: lang == 'zh' }" v-on:click="closeMenu" href="/zh">{{ langName('zh') }}</a>
                    <a v-bind:class="{curr: lang == 'hi' }" v-on:click="closeMenu" href="/hi">{{ langName('hi') }}</a>
                </div>
                <div id="close"></div>
            </nav>
            <div class="phone"><a href="tel:+78435280548">+7 (843) <span class="bold">528-05-48</span></a></div>
            <div class="lang">
                <span class="ins">{{ langNameComputed }}</span>
                <ul class="submenu">
                    <li><a href="/ru">{{ langName('ru') }}</a></li>
                    <li><a href="/en">{{ langName('en') }}</a></li>
                    <li><a href="/zh">{{ langName('zh') }}</a></li>
                    <li><a href="/hi">{{ langName('hi') }}</a></li>
                </ul>
            </div>
            <div id="burger"></div>
        </div>
    </header>
</template>

<script>
    export default {
        created: function () {
            setTimeout(
                    function () {
                        PageScript();
                    }, 500);
        },
        data: function () {
            return {
                content: {
                    ru: {
                        SOLUTIONS: "Решения",
                        SERVICES: "Услуги",
                        PRESS_CENTER: "Пресс-центр",
                        COMPANY: "Компания",
                        ENGINEERING: "Проектирование",
                        DEVELOPMENT: "Разработка",
                        CONSULTING: "Консалтинг",
                        ABOUT_COMPANY: "О компании",
                        DOCUMENTS: "Рекомендации",
                        CAREER: "Карьера",
                        CONTACTS: "Контакты"
                    },
                    en: {
                        SOLUTIONS: "Solutions",
                        SERVICES: "Services",
                        PRESS_CENTER: "Press center",
                        COMPANY: "Company",
                        ENGINEERING: "Design",
                        DEVELOPMENT: "Software Development",
                        CONSULTING: "Consulting",
                        ABOUT_COMPANY: "About us",
                        DOCUMENTS: "Recommendations",
                        CAREER: "Career",
                        CONTACTS: "Contacts"
                    },
                    zh: {
                        SOLUTIONS: "解决方案",
                        SERVICES: "服务",
                        PRESS_CENTER: "新闻处",
                        COMPANY: "公司",
                        ENGINEERING: "设计",
                        DEVELOPMENT: "软件的开发",
                        CONSULTING: "咨询 ",
                        ABOUT_COMPANY: "关于公司",
                        DOCUMENTS: "推荐",
                        CAREER: "前程",
                        CONTACTS: "联系方式"
                    },
                    hi: {
                        SOLUTIONS: "समाधान",
                        SERVICES: "सेवाएं",
                        PRESS_CENTER: "प्रेस सेंटर",
                        COMPANY: "कंपनी",
                        ENGINEERING: "डिजाइनिंग",
                        DEVELOPMENT: "सॉफ्टवेयरकाविकास",
                        CONSULTING: "परामर्श",
                        ABOUT_COMPANY: "कंपनीकेबारेमें",
                        DOCUMENTS: "सिफारिशें",
                        CAREER: "कैरियर",
                        CONTACTS: "संपर्क"
                    }
                }
            }
        },
        computed: {
            lang: function () {
                return this.$route.params.lang != null ? this.$route.params.lang : Application.props.defaultLang
            },
            langNameComputed: function() {
                return this.langName();
            }

        },
        methods: {
            langName: function(l) {
                if (l == null) {
                    l = this.lang;
                }

                if (l == 'ru') {
                    return 'РУС';
                }
                else if (l == 'en') {
                    return 'ENG';
                }
                else if (l == 'zh') {
                    return '汉语';
                }
                else if (l == 'hi') {
                    return 'हिन्दी';
                }
            },
            closeMenu: function () {
                if ($('html').width() < 888) {
                    $('#close').click();
                }
            }
        }
    }

    var PageScript = function () {
        // BODY RESIZE HANDLER
        var __cw = $('html').width();

        function bodyResize() {
            var __ncw = $('html').width();
            if (__ncw > 888 && __cw <= 888 || __ncw <= 888 && __cw > 888) {
                mainMenu(__ncw);
            }
            __cw = __ncw;
        }

        function makeShadow() {
            var count = $('nav li .title').length;
            for (var i = 0; i < count; i++) {
                var name = $('nav li .title').eq(i).html();
                var addingHtml = '<div class="with_shadow">' + name + '</div>';
                $('nav li .title').eq(i).parent('.wrap').prepend(addingHtml);
            }

            var name = $('.lang .ins').html();
            var addingHtml = '<div class="with_shadow with_shadow_lang">' + name + '</div>';
            $('.lang').prepend(addingHtml);
        }

        makeShadow();

        $(window).on('resize', function () {
            bodyResize();
        });

        function mainMenu(__cw) {
            if (__cw <= 888) {
                $('nav').hide();
                $('.cover').hide();

                $('header nav ul li .title').click(function () {
                    var submenu = $(this).siblings('.submenu');
                    if (submenu.is(':visible')) {
                        submenu.hide();
                        $(this).removeClass('opened');
                        $(this).parent('li').removeClass('opened');
                        $(this).parent('.wrap').parent('li').removeClass('opened');

                    } else {
                        submenu.show();
                        $(this).addClass('opened');
                        $(this).parent('.wrap').parent('li').addClass('opened');
                    }
                });
            }
            else if (__cw > 888) {
                $('nav').css('display','inline-table');

                $('header nav ul li').mouseenter(function () {
                    var submenu = $(this).children('.wrap').children('.submenu');
                    submenu.show();
                    var withShadow = $(this).children('.wrap').children('.with_shadow');
                    withShadow.html($(this).children('.wrap').children('.title').html());
                    withShadow.show();
                });
                $('header nav ul li').mouseleave(function () {
                    var submenu = $(this).children('.wrap').children('.submenu');
                    submenu.hide();
                    $(this).children('.wrap').children('.with_shadow').hide();
                });
                $('header .lang').mouseenter(function () {
                    var submenu = $(this).children('.submenu');
                    submenu.show();
                    var withShadow = $(this).children('.with_shadow');
                    withShadow.html($(this).children('.ins').html());
                    withShadow.show();
                });
                $('header .lang').mouseleave(function () {
                    var submenu = $(this).children('.submenu');
                    submenu.hide();
                    $(this).children('.with_shadow').hide();
                });

            }
        }
        $('#burger').click(function () {
            $('nav').show();
            $('.cover').show();

        });
        $('#close').click(function () {
            $('nav').hide();
            $('.cover').hide();
        });

        mainMenu(__cw);
    }
</script>



// WEBPACK FOOTER //
// VHeader.vue?6f6889c2